// その他の求人
import { fadeIn, fadeOut } from '@pc/components/Fade'
import axios, { type AxiosRequestConfig } from 'axios'

const groupWorks = document.querySelectorAll<HTMLElement>('.js-group-works')
const groupModalOpen = document.querySelectorAll<HTMLElement>('.js-group-modal-open')
const groupModalClose = document.querySelectorAll<HTMLElement>('.js-group-modal-close')
const groupModal = document.querySelectorAll<HTMLElement>('.js-group-modal')
const groupModalDialog = document.querySelectorAll<HTMLElement>('.js-group-modal-dialog')
const groupModalParams = document.querySelectorAll<HTMLInputElement>('.js-group-model-params')
const groupModalBody = document.querySelectorAll<HTMLElement>('.js-group-model-body')
const groupModalButton = document.querySelectorAll<HTMLElement>('.js-group-modal-button')

export function displayGroupWorks() {
  if (groupWorks.length === 0 || groupModalOpen.length === 0) return
  if (groupWorks.length !== groupModalOpen.length) return

  for (let i = 0; i < groupWorks.length; i++) {
    const requester = createRequester(i)
    groupModalOpen[i].addEventListener('click', () => {
      fadeIn(groupModal[i])
      requestFirstPage(requester, i)
    })
    groupModalClose[i].addEventListener('click', () => {
      const body = groupModalBody[i]
      body.innerHTML = ''
      requester.refresh()
      fadeOut(groupModal[i])
    })
    groupModalButton[i].addEventListener('click', () => {
      requestNextPage(requester, i)
    })
    groupModalDialog[i].addEventListener('click', (e) => {
      e.stopPropagation()
    })
  }
}

function createRequester(index: number) {
  const json: GroupParams = JSON.parse(groupModalParams[index].value)
  const params = new GroupParams(json.fq, json.sort, json.shops_group, json.work_id, 1)
  const requester = new GroupRequester(params)
  requester.errorHandler = (error) => {
    console.error(error)
  }
  requester.finishedHandler = () => {}
  return requester
}

function requestFirstPage(requester: GroupRequester, index: number) {
  requester.successHandler = (data) => {
    const body = groupModalBody[index]
    const insertHtml = insertData(data)
    body.innerHTML = insertHtml
    groupModalButton[index].style.display = data.total_page !== data.page ? 'block' : 'none'
  }
  requester.fetch()
}

function requestNextPage(requester: GroupRequester, index: number) {
  requester.successHandler = (data) => {
    const body = groupModalBody[index]
    const insertHtml = insertData(data)
    body.innerHTML += insertHtml
    if (data.total_page === data.page) {
      groupModalButton[index].style.display = 'none'
    }
  }
  requester.nextFetch()
}

function insertData(data: any) {
  let html = ''
  data.works.forEach((work: { id: string; name: string }) => {
    html += createHtmlTag(work.id, work.name)
  })
  return html
}

function createHtmlTag(id: string, name: string) {
  return (
    "<ul class='p-works-grouped-works-ul-style'><li class='p-works-grouped-works-li-style'><a href=\"/detail/" + id + '">' + name + '</a></li></ul>'
  )
}

class GroupParams {
  fq: string
  sort: string
  shops_group: string
  work_id: string
  page: number

  constructor(fq: string, sort: string, shopsGroup: string, workId: string, page: number) {
    this.fq = fq
    this.sort = sort
    this.shops_group = shopsGroup
    this.work_id = workId
    this.page = page
  }
}
class GroupRequester {
  params: GroupParams
  successHandler: (data: any) => void = () => {}
  errorHandler: (error: any) => void = () => {}
  finishedHandler: () => void = () => {}

  constructor(params: GroupParams) {
    this.params = params
  }

  async fetchGroupWorks(params: any) {
    const response = await axios.get('/api/groups', { params } satisfies AxiosRequestConfig)
    return response.data
  }

  fetch() {
    void this.fetchGroupWorks(this.params)
      .then((data) => {
        this.successHandler(data)
      })
      .catch((error) => {
        this.errorHandler(error)
      })
      .finally(() => {
        this.finishedHandler()
      })
  }

  nextFetch() {
    this.params.page++
    void this.fetchGroupWorks(this.params)
      .then((data) => {
        this.successHandler(data)
      })
      .catch((error) => {
        this.errorHandler(error)
      })
      .finally(() => {
        this.finishedHandler()
      })
  }

  refresh() {
    this.params.page = 1
  }
}
